<template>
  <div class="pb-6 flex flex-col gap-4">
    <ChatGPTEditorFormRowFull :item="INSTRUCTIONS"
                              :is-item-error="false"
                              :row-count="20"
                              :token-count="promptTokenCount"
                              :is-disabled="true"
                              :action="displayAction"
    />
  </div>
</template>

<script>
import ChatGPTEditorFormRowFull from '@/components/editor/ChatGPTEditorFormRowFull'
import { CHAT_GPT_EDITOR_PROPS } from '@/constants/chat-gpt.constants'
import { mergeLegacyPrompts } from '@/utils/chat-gpt-action.utils'
import $script from 'scriptjs'

const { INSTRUCTIONS } = CHAT_GPT_EDITOR_PROPS

export default {
  name: 'ChatGPTActionDetailPrompt',

  components: { ChatGPTEditorFormRowFull },

  props: {
    action: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      tokenizer: null,
      INSTRUCTIONS
    }
  },

  computed: {
    // PRO-740: older history carries a separate user prompt — show it the way the editor does now
    displayAction() {
      return mergeLegacyPrompts(this.action)
    },

    promptTokenCount() {
      const prompt = this.displayAction?.prompt
      if (!prompt) return 0

      return this.tokenizer?.encode(prompt).length || 0
    }
  },

  methods: {
    async initTokenizer() {
      if (!window.GPTTokenizer_cl100k_base) {
        await new Promise(resolve => $script('https://unpkg.com/gpt-tokenizer', resolve))
      }
      this.tokenizer = window.GPTTokenizer_cl100k_base
    }
  },

  async mounted() {
    await this.initTokenizer()
  }
}
</script>
